module.exports = __webpack_public_path__ + "static/img/Luke_Shuey_mobile.83fe96e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Luke_Shuey_mobile.jpg
// module id = A7WL
// module chunks = 0